import React, { useState } from 'react';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/Button';

import { declarationSignedFalse } from '../helpers/declarationFields';
import { choosePatient } from '../../../actions/appointmentsActions';
import OperatorForm from './operator';
import RenderPatient from '../common/renderPatient';
import ReferralInput from '../../components/refferal';

const ChoosePatient = ({
  handleSubmit,
  onSubmit,
  patients,
  register,
  error,
  isOperator,
  operatorPatients,
  operatorPatientsLoaded,
  isOperatorChooseOtherPatient,
  updateAppointmentState,
  watch,
  control,
  timeSlot,
  referralNumber,
  setReferralNumber,
  formErrors,
  trigger,
}) => {
  
  const [isTelemedicine, setTelemedicine] = useState(false);
  const [registeringAnotherPatient, setRegisteringAnotherPatient] = useState(false);
  const onCheck = () => setTelemedicine((prevState) => !prevState);
  
  if (isOperator)
    return (
      <OperatorForm
        watch={watch}
        control={control}
        register={register}
        handleSubmit={handleSubmit}
        error={error}
        onSubmit={onSubmit}
        operatorPatients={operatorPatients}
        operatorPatientsLoaded={operatorPatientsLoaded}
        isOperatorChooseOtherPatient={isOperatorChooseOtherPatient}
        updateAppointmentState={updateAppointmentState}
      />
    );
  
    patients.data = patients.data.filter((patient) => patient.id !== 0);
    
  if ((patients.loaded && (patients.data.length ?? 0) === 0) || registeringAnotherPatient) {
    return (
      <form onSubmit={handleSubmit(onSubmit)} className="confirmation_of_entry confirmed">
        <ReferralInput
          register={register}
          style={{ marginTop: '15px' }}
          timeSlot={timeSlot}
          referralNumber={referralNumber}
          setReferralNumber={setReferralNumber}
          formErrors={formErrors}
          error={error}
          trigger={trigger}
        />

        <input type="hidden" name="patient" value="other" ref={register} />
        <p className="appointment-auth-text">Кого ви хочете записати на прийом:</p>
        <div className="info_box declaration_false">
          <div className="user_info_box">
            {error && typeof error === 'string' && <span className="error">{error}</span>}
            {declarationSignedFalse.map(({ text, input, Component }) => (
              <Component key={text} text={text} error={error} input={input} register={register} control={control} />
            ))}
          </div>
        </div>
        
        {registeringAnotherPatient && (
          <p className="text-center">
            <Button 
              variant="outline-primary" 
              onClick={() => setRegisteringAnotherPatient(false)} 
              className="mb-3">
              Обрати пацієнта зі списку
            </Button>
          </p>
        )}

        <Button type="submit" variant="primary" className="submit-button">
          Підтверджую
        </Button>
      </form>
    );
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="confirmation_of_entry confirmed">
      <ReferralInput
        register={register}
        style={{ marginTop: '15px' }}
        timeSlot={timeSlot}
        referralNumber={referralNumber}
        setReferralNumber={setReferralNumber}
        formErrors={formErrors}
        error={error}
        trigger={trigger}
      />
      <p className="appointment-auth-text">Виберіть кого ви хочете записати на прийом:</p>
      <div className={patients.loaded ? null : 'confirmation_of_entry__patients-loading'}>
        {patients.loaded
          ? patients.data.map((patient) => (
              <RenderPatient
                key={patient.id}
                currentPatientId={
                  localStorage.getItem('patientId') && localStorage.getItem('patientId') > 0 ? +localStorage.getItem('patientId') : patients.data[0].id
                }
                register={register}
                patient={patient}
              />
            ))
          : 'Завантаження ...'}
      </div>
      
      {patients.loaded && (
        <p className="text-center">
          <Button 
            variant="outline-primary" 
            className="mt-3 mb-3" 
            onClick={() => setRegisteringAnotherPatient(true)}>
            Записати іншого пацієнта на прийом
          </Button>
        </p>
      )}
      
      {error && typeof error === 'string' && (
        <div className="error_text" style={{ opacity: error ? 1 : 0, float: 'inherit', border: 0 }}>
          {error}
        </div>
      )}

      {timeSlot.is_telemedicine && (
        <label className="checkbox" style={{ 'border': 0, 'padding': '15px 0' }}>
          <input
            type="checkbox"
            name="is_video_conference"
            checked={isTelemedicine}
            ref={register({  })}
            onChange={onCheck}
          />
          <div className="checkbox__text" style={{ color: '#000' }}>
            Я хочу провести <b>прийом Онлайн</b> (телеконсультація за допомогою відео зв'язку - посилання на Онлайн консультацію буде доступно в Вашому кабінеті в розділі "Записи на прийом" за 10 хв до початку прийому).
          </div>
        </label>
      )}

      <Button type="submit" variant="primary" className="submit-button" disabled={!patients.loaded}>
        Підтверджую
      </Button>
    </form>
  );
};

const mapDispatchToProps = { choosePatient };

export default connect(null, mapDispatchToProps)(ChoosePatient);
